/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { ApplicationsContext } from '@/context';
import { ApplicationsContextValue } from '@/providers/ApplicationsProvider';

export const useApplications = () => {
  const context = useContext(
    ApplicationsContext
  ) as ApplicationsContextValue | null;

  if (!context) {
    throw new Error(
      'useApplications must be used within an ApplicationsProvider'
    );
  }

  return context;
};
